'use strict';

/**
 * Identify the customer when they sign in/register
 * To avoid events from being mapped to wrong profile
 */
function klaviyoIdentify(url) {
    // check if klaviyo is enabled, else exit
    if (document.getElementsByName('isKlaviyoEnabled').length && $(document.getElementsByName('isKlaviyoEnabled')[0]).val() === "true") {
        // Klaviyo - identify customer
        var klaviyoJS = {};
        var klaviyoCookie = document.cookie.split('; ').filter(function (c) { return /__kla_id=/.test(c) });
        
        // Check if the cookie is found
        if (klaviyoCookie.length === 0) {
            console.warn('Klaviyo cookie not found. Identification cannot proceed.');
            return; // Exit early if cookie is not found
        } else {
            var exchangeID;
            // Extract and parse the cookie
            exchangeID = JSON.parse(atob(klaviyoCookie[0].split("__kla_id=")[1])).$exchange_id;

            var email = '';

            // Check for the correct email based on the form and URL
            if (url.length && url.indexOf('SubmitRegistration') === -1 && $('#login-form-email').length && $('#login-form-email').val().length) {
                email = $('#login-form-email').val();
            } else if ($('#registration-form-email').length && $('#registration-form-email').val().length) {
                email = $('#registration-form-email').val();
            }

            // Identify the user if an email is available
            if (email && email.length) {
                window.klaviyo.identify({ '$email': email }).then(() => {
                    klaviyoJS.identifiedUser = true;
                    klaviyoJS.exchangeID = exchangeID;
                }).catch(error => {
                    console.error('Error during Klaviyo identify:', error);
                });

                Promise.resolve(window.klaviyo.isIdentified()).then(result => {
                    klaviyoJS.identifiedUser = result;
                }).catch(error => {
                    console.error('Error checking Klaviyo identify status:', error);
                });
            }
        }
    }
}

module.exports = {
    klaviyoIdentify: klaviyoIdentify
}
